/* eslint-disable @typescript-eslint/naming-convention */
export interface ContentSearch {
  search_time?: number;
  processing_time?: number;
  translation_time?: number;
  translated_query?: string;
  results_summary?: string | null;
  search_results?: ContentSearchResultEntry[] | null;
  sub_category_lists?: string[];
  subCategoryFilterName?: string;
  next_page_token?: string;
  total_size?: number;
}

export interface ContentSearchResultEntry {
  category: ContentCategory;
  thumbnail_image: string;
  title: string;
  link: string;
  html_title: string;
  display_link: string;
  snippets?: string[] | null;
  content_card?: ContentCard;
  promotion_date?: string;
  sub_category?: string;
}

export interface ContentCard {
  color: ColorMetaData;
  read_time: string;
  thumbnail_image: string;
}

export interface ColorMetaData {
  background_color: string;
  text_color: string;
}

export enum ContentCategory {
  Article = 'Articles',
  Offers = 'Offers',
}
